const amountOfTaskMessageTemplatesOnPage = 6;

export default amountOfTaskMessageTemplatesOnPage;
